<template>
    <v-container fluid>
       
       <v-alert type="info"  dismissable value="true" v-if="!permission">You do not have permission to edit this page</v-alert>
       <v-alert type="info"  dismissable value="true" v-if="metadata.info">{{ metadata.info }}</v-alert>
       <v-alert type="warn"  dismissable value="true" v-if="metadata.warn">{{ metadata.warn }}</v-alert>
       <v-alert type="error" dismissable value="true" v-if="metadata.error">{{ metadata.error }}</v-alert>


       <v-alert color="warning" icon="priority_high" v-model="updatedUpstream">
           Some of this data has been updated by <strong>{{ upstreamChanges.userName }} ({{ upstreamChanges.userType }})</strong> since you opened this page

			<v-row>
			   <v-col sm="12" v-for="(field, key) in upstreamChanges.record_changes" :key='key' xs12>
				   <v-container fluid>
					   <v-row wrap>
						   <v-col sm="12">
							   '<strong>{{ field.fieldName }}</strong>'
							   was changed from
							   '<strong>{{field.old_value }}</strong>'
							   to
							   '<strong>{{ field.new_value }}</strong>'
						   </v-col>
					   </v-row>
				   </v-container>
			   </v-col>
			</v-row>

			<v-row>
				<v-col sm="12">If you save without applying these first then some of their changes may be lost.  Click the button below to try to update the data on this page</v-col>
				<v-col sm="12">			
					<v-btn v-on:click="updatePage()">Update page</v-btn>
					<v-btn v-on:click="reloadPage()">Reload Page (Discard Changes)</v-btn>
					<v-btn v-on:click="openNew()">Open In New Tab</v-btn>
				</v-col>
			</v-row>
       </v-alert>

       <form id="editForm" v-on:submit.prevent>

	   <v-card v-if="validationErrors.length" class="mb-2 pa-3 ies-coral">
	       <div class="mb-2">
	           <v-icon class="mr-2">error</v-icon>
	           <strong>Validation Failed:</strong>
	       </div>
	       <div class="mb-0">
	           <div v-for="(errorField, i) in validationErrors" :key="i">
	               <strong>{{ errorField.fieldName }}</strong>
	               <ul>
	                   <li v-for="(msg, j) in errorField.errors" :key="j">{{ msg.reason }}</li>
	               </ul>
	           </div>
	       </div>
	   </v-card>

       <v-card class="no-print d-flex flex-wrap d-md-none">
               <v-btn class="ies-green" v-on:click="saveRecord(metadata.primaryKey)" v-if="permission" :disabled="saving"><v-icon>save</v-icon></v-btn>
               <v-btn class="ml-1 ies-coral" v-on:click="deleteRecord()" v-if="permission" :disabled="true"><v-icon>delete</v-icon></v-btn>
               <v-btn class="ml-1" v-on:click="goToNewRecord()" v-if="permission"><v-icon>add</v-icon></v-btn>
               <v-btn class="ml-1" v-on:click="duplicateRecord()" v-if="permission"><v-icon>content_copy</v-icon></v-btn>
               <v-btn class="ml-1" v-on:click="emailLink()"><v-icon>email</v-icon></v-btn>
               <v-btn class="ml-1" v-on:click="listView()"><v-icon>view_list</v-icon></v-btn>
               <v-btn class="ml-1" v-on:click="returnToDashboard()" :disabled="!metadata.parentPage"><v-icon>dashboard</v-icon> Dash</v-btn>
               <v-btn class="ml-1" v-on:click="reportProblem()"><v-icon>report_problem</v-icon></v-btn>
           </v-card>
           <v-card class="no-print d-none d-md-flex flex-wrap">
               <v-btn class="ies-green" v-on:click="saveRecord(metadata.primaryKey)" v-if="permission" :disabled="saving"><v-icon>save</v-icon> Save</v-btn>
               <v-btn class="ml-1 ies-coral" v-on:click="deleteRecord()" v-if="permission" :disabled="true"><v-icon>delete</v-icon> Delete</v-btn>
               <v-btn class="ml-1" v-on:click="goToNewRecord()" v-if="permission"><v-icon>add</v-icon> Add New</v-btn>
               <v-btn class="ml-1" v-on:click="duplicateRecord()" v-if="permission"><v-icon>content_copy</v-icon> Clone</v-btn>
               <v-btn class="ml-1" onClick="window.print()"><v-icon>print</v-icon> Print</v-btn>
               <v-btn class="ml-1" v-on:click="emailLink()"><v-icon>email</v-icon> Email</v-btn>
               <v-btn class="ml-1" v-on:click="listView()"><v-icon>view_list</v-icon> List</v-btn>
               <v-btn class="ml-1" v-on:click="reloadPage()"><v-icon>refresh</v-icon></v-btn>
               <v-btn class="ml-1" v-on:click="returnToDashboard()" :disabled="!metadata.parentPage"><v-icon>dashboard</v-icon> Dash</v-btn>
               <v-btn class="ml-1" v-on:click="reportProblem()"><v-icon>report_problem</v-icon> Problem</v-btn>
           </v-card>


           <v-card>
                <v-row class="ma-3" >
					<v-col v-for="(section,i) in formSections" :key="i" v-if="checkSection(section)" cols="12" sm="12" md="12" :lg="section.sectionWidth ? section.sectionWidth : 12">
			<v-card flat class="ma-3">
				<fieldset>
				<legend v-if="section.sectionName">{{ section.sectionName }}</legend>

				<v-alert type="info"  dismissable value="true" v-if="section.info">{{ section.info }}</v-alert>
				<v-alert type="warn"  dismissable value="true" v-if="section.warn">{{ section.warn }}</v-alert>
				<v-alert type="error" dismissable value="true" v-if="section.error">{{ section.error }}</v-alert>
                <div v-if="section.introduction">{{ section.introduction }}</div>

				<v-row>
					<v-col v-for="(field,k) in section.fields" :key="k" v-if="field.displayType != 'hidden'" cols="12" sm="12" :md="field.fieldWidth ? field.fieldWidth : 12" :lg="field.fieldWidth ? field.fieldWidth : 12">
                        <ies-input-wrapper 
                            :field="field" 
                            :recordData="resultsArray"
                            :page="pageRecord"
                        ></ies-input-wrapper>
					</v-col>
				</v-row>

				<div v-if="section.outroduction">{{ section.outroduction }}</div>
				</fieldset>
			</v-card>
					</v-col>
				</v-row>
			</v-card>

           <v-card class="no-print d-flex flex-wrap d-md-none">
               <v-btn class="ies-green" v-on:click="saveRecord(metadata.primaryKey)" v-if="permission" :disabled="saving"><v-icon>save</v-icon></v-btn>
               <v-btn class="ml-1 ies-coral" v-on:click="deleteRecord()" v-if="permission"><v-icon>delete</v-icon></v-btn>
               <v-btn class="ml-1" v-on:click="goToNewRecord()" v-if="permission"><v-icon>add</v-icon></v-btn>
               <v-btn class="ml-1" v-on:click="duplicateRecord()" v-if="permission"><v-icon>content_copy</v-icon></v-btn>
               <v-btn class="ml-1" v-on:click="emailLink()"><v-icon>email</v-icon></v-btn>
               <v-btn class="ml-1" v-on:click="listView()"><v-icon>view_list</v-icon></v-btn>
               <v-btn class="ml-1" v-on:click="returnToDashboard()" :disabled="!metadata.parentPage"><v-icon>dashboard</v-icon> Dash</v-btn>
               <v-btn class="ml-1" v-on:click="reportProblem()"><v-icon>report_problem</v-icon></v-btn>
           </v-card>
           <v-card class="no-print d-none d-md-flex flex-wrap">
               <v-btn class="ies-green" v-on:click="saveRecord(metadata.primaryKey)" v-if="permission" :disabled="saving"><v-icon>save</v-icon> Save</v-btn>
               <v-btn class="ml-1 ies-coral" v-on:click="deleteRecord()" v-if="permission"><v-icon>delete</v-icon> Delete</v-btn>
               <v-btn class="ml-1" v-on:click="goToNewRecord()" v-if="permission"><v-icon>add</v-icon> Add New</v-btn>
               <v-btn class="ml-1" v-on:click="duplicateRecord()" v-if="permission"><v-icon>content_copy</v-icon> Clone</v-btn>
               <v-btn class="ml-1" onClick="window.print()"><v-icon>print</v-icon> Print</v-btn>
               <v-btn class="ml-1" v-on:click="emailLink()"><v-icon>email</v-icon> Email</v-btn>
               <v-btn class="ml-1" v-on:click="listView()"><v-icon>view_list</v-icon> List</v-btn>
               <v-btn class="ml-1" v-on:click="reloadPage()"><v-icon>refresh</v-icon></v-btn>
               <v-btn class="ml-1" v-on:click="returnToDashboard()" :disabled="!metadata.parentPage"><v-icon>dashboard</v-icon> Dash</v-btn>
               <v-btn class="ml-1" v-on:click="reportProblem()"><v-icon>report_problem</v-icon> Problem</v-btn>
           </v-card>

	   <v-card v-if="validationErrors.length" class="mt-2 pa-3 ies-coral">
	       <div class="mb-2">
	           <v-icon class="mr-2">error</v-icon>
	           <strong>Validation Failed:</strong>
	       </div>
	       <div class="mb-0">
	           <div v-for="(errorField, i) in validationErrors" :key="i">
	               <strong>{{ errorField.fieldName }}</strong>
	               <ul>
	                   <li v-for="(msg, j) in errorField.errors" :key="j">{{ msg.reason }}</li>
	               </ul>
	           </div>
	       </div>
	   </v-card>

       </form>

        <v-snackbar
        :timeout="parseInt(6000)"
        v-model="successSnackbar"
        multi-line
        color="ies-green"
        > 
           <div class="full-height full-width v-align-container text-xs-center">
              <h4 class="ies-dark-gray--text v-align-div">Record Saved</h4>
           </div>
        </v-snackbar>
        <v-snackbar
        :timeout="parseInt(6000)"
        v-model="errorSnackbar"
        multi-line
        color="ies-coral"
        >
           <div class="full-height full-width v-align-container text-xs-center">
              <h4 class="ies-dark-gray--text v-align-div">{{ errorMessage }}</h4>
           </div>
        </v-snackbar>
    </v-container>
</template>


<script>
    import axios from 'axios';

export default {
    name: 'edit',
    props: ['page', 'sectionsData','resultsData', 'metadata', 'permission', 'breadcrumbsData'],
    data () {
        return {
            errorMessage:     '',
            errorSnackbar:    false,
            successSnackbar:  false,
            saving:           false,
            unsavedChanges:   false,
            updatedUpstream:  false,
            pageRecord:       {},
            pageOpened:       Date.now() / 1000,
            lastSaved:        Date.now() / 1000,
            lastUpdated:      0,
            upstreamChanges:  [],
            redirectToUrl:    false,
            formSections:     [],
            isBroken:         false,
            validationErrors: []
        }
    },

    methods: { 
        /**
         * Co-ordinate the saving of the record to the database
         */   
        saveRecord (){
            console.log("window location pathname", window.location.pathname);
            console.log("EDIT: saving record ", this.metadata);
            console.log("stuff: ", this.resultsData);
            console.log("results are ", this.resultsData.data);

            // Clear any previous validation errors
            this.validationErrors = [];

            // Validate form submission
            if (!this.jsValidationIsOkay()){
                document.getElementById('editForm').reportValidity();
                this.errorMessage = 'Save Failed';
                this.errorSnackbar = true;
                console.log("cannot save: js validation failed");
                return;
            }

            // One last line of defence against people accidentally overwriting other people's changes - make them confirm they know what they're doing
            if (!this.upstreamUpdateIsOkay()){
                this.errorMessage = 'Save Failed';
                this.errorSnackbar = true;
                console.log("will not save: upstream changes");
                return;
            }

            let saveUrl = this.buildSaveUrl();

            if (!saveUrl){
                this.errorMessage = 'Save Failed';
                this.errorSnackbar = true;
                console.log("cannot save: no save url");
                return;
            }

            console.log("I would save to ", saveUrl);

            this.postSaveData(saveUrl);
        },

        jsValidationIsOkay(){
            return document.getElementById('editForm').checkValidity();
        },

        upstreamUpdateIsOkay(){
            if (!this.updatedUpstream){
                return true;
            }

            if (confirm("Warning, some of the data on this page has been changed by another user\n\nClick Ok to overwrite their changes with the data on this page")){
                return true;
            }

            return false;
        },

        buildSaveUrl(){            
            // We can use this component to either create a new record or update an existing one, so
            // it is important that we know what url we will submit the requests to incase they differ
            // Check if the current URL is a create page, else default to update url
            // At the moment the crude check in place is looking for the word create in the url, as otherwise
            // the url will not be an exact string match for the create url string pattern - this should be
            // converted to use regular expressions I think to avoid clumsy checks for substrings like this
            // but right now this is itself a step forwards from what existed before
            // I am not sure whether to try to use the url patterns from the data, or just submit to the same url as now
            if (window.location.pathname.includes('create')){
                return this.populateUrlFromThisUrl(this.pageRecord.create_url, this.pageRecord.create_url) || window.location.pathname; 
            }

            // Otherwise, in the context of an update the record will have data, so we can
            // populate the edit url accordingly, otherwise in create mode we can only
            // submit to the url itself at this time.  Again, I am not sure this is any better than saving to the current
            // url which should be fine as is, but it is being used to help develop the methods which are going to be used
            // in other places, like generating list view links etc
            if (this.resultsData && this.resultsData.fields && this.resultsData.fields.length){
                return this.populateUrlFromResults(this.pageRecord.edit_url) || window.location.pathname;
            }

            return window.location.pathname;
        },

        postSaveData(saveUrl){
             // Create a copy of the data to be submitted to the server via AJAX
            let submissionData = this.formSections;
            let requestConfig = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            console.log("here i am...", this);
            console.log("my submission will be ", saveUrl, submissionData, requestConfig);
            let saveSucceeded = false;
            this.saving = true;
            axios.post(saveUrl, {params:submissionData}, requestConfig)
                .then(function(response){
                    var self = this;

                    console.log(response.data);
                    if(!response.data.success) {
                        this.errorMessage = 'Save Failed';
                        this.errorSnackbar = true;

                        // The individual input components are not directly controlled by this parent component
                        // and so communicating with them requires event listeners to be used to announce the
                        // validation/save response errors
                        console.log(response.data.errors);
                        this.validationErrors = response.data.errors || [];
                        this.validationErrors.forEach(function(errorField){
                            console.log("my mistake: ", errorField);
                            self.$root.$emit('Field: set errors', errorField);
                        });
                        this.saving = false;
                    }
                    else if(response.data.success) {
                        saveSucceeded = true;
                        this.successSnackbar = true;
                        this.lastUpdated     = Date.now() / 1000;
                        this.lastSaved       = this.lastUpdated;

                        // emit an event that SAVE button was clicked so we can catch it in other vue-components
                        this.$eventHub.$emit('save-button-clicked', {id: 'NONE', url: saveUrl});

                        console.log("Perform post save redirections");

                        // Post save redirect logic: at the moment just send the user to the list page
                        this.listView();
                        this.saving = false;
                    }
                }.bind(this))
                .catch(function(error){
                    console.error("Error:", error);
                    this.errorMessage = saveSucceeded
                        ? 'Record saved, but an error occurred on the page afterwards — please refresh the page'
                        : 'Save Failed';
                    this.errorSnackbar = true;
                    this.saving = false;
                }.bind(this));

        },


        populateUrlFromThisUrl(urlPattern, thisUrlPattern)
        {
            if (!urlPattern || !thisUrlPattern){
                return;
            }

            console.log("Will populate the url ", urlPattern, "from current url using pattern ", thisUrlPattern);
            var url = urlPattern;
            var find = [];
            var replace = [];
            var thisUrlPatternParts = thisUrlPattern.split('/');
            var thisUrlParts = window.location.pathname.replace(/^\/|\/$/g, '').split('/');
            console.log(thisUrlPatternParts, thisUrlParts);

            // Extract data from the current page url by analysing it according
            // to whatever pattern it is following - data will be in the bits
            // where the base pattern contains placeholder tags {xyz}
            for(var index = 0; index < thisUrlPatternParts.length; index++){
                if (thisUrlPatternParts[index].includes('{')){
                    find.push(thisUrlPatternParts[index]);
                    replace.push(thisUrlParts[index]);
                }
            }
            console.log(find, replace, url);

            // Replace any of the placeholder tags found in the template with the corresponding values
            for(var index = 0; index < find.length; index++){
                url = url.replace(find[index], replace[index]);
            }
            return url;
        },

        // required?
        populateUrlFromResults(url)
        {
            if (!url){
                return;
            }
            console.log("Will populate the url ", url, "from resultsset");
            var self = this;
            var find = [];
            var replace = [];

            this.resultsData.fields.forEach(function(field){
                find.push('{' + field.modelName + '.' + field.fieldName + '}');
                replace.push(self.resultsData.data[0][field.fieldName]);
            });
            console.log('fr', find, replace);

            // Replace any of the placeholder tags found in the template with the corresponding values
            for(var index = 0; index < find.length; index++){
                url = url.replace(find[index], replace[index]);
            }
            return url;
        },

        /**
         * @method deleteRecord
         *
         * Call the route which triggers the record to be deleted
         */
        deleteRecord ()
        {
            // Check if the user really wishes to delete the record, then call the URL
            if (confirm("Are you sure you want to delete this record?")){
                var deleteUrl = '/' + this.metadata.deleteUrl;
                var self = this;
                var find = [];
                var replace = [];
                this.resultsData.fields.forEach(function(field){
                    find.push('{' + field.modelName + '.' + field.fieldName + '}');
                    replace.push(self.resultsData.data[0][field.fieldName]);
                });
                console.log('fr', find, replace);

                // Replace any of the placeholder tags found in the template with the corresponding values
                for(var index = 0; index < find.length; index++){
                    deleteUrl = deleteUrl.replace(find[index], replace[index]);
                }
              
                axios.delete(deleteUrl)
                .then(function(response){
                    console.log(response);
                    //this.listView();
                }.bind(this));
            }
        },

        /**
         * @method goToNewRecord
         *
         * Method to coordinate requesting the add-new feature for creating a new record
         * of the type currently being viewed
         */
        goToNewRecord: function()
        {
            // If this page's record has a specific url to use then we just populate that pattern and use it
            // I am not sure we need to pass in the list url property when we could pass in the page url pattern which must always be set
            if (this.pageRecord.create_url){
                console.log("page record is ", this.pageRecord);
                window.location = '/' + this.populateUrlFromThisUrl(this.pageRecord.create_url, this.pageRecord.page_url_pattern);
            }
            // By default we view a record in edit mode by visiting this same URL but with the ID on the end
            else {
                console.log("No create url set in list page record, will default to page name + create suffix");
                window.location = '/' + this.pageRecord.page_name + '/create';
            }
        },

        /**
         * @method cloneRecord
         *
         * Requests that the current record is duplicated in the database to save the user
         * from then having to manually copy and paste data from one tab to another
         */
        duplicateRecord: function()
        {
            if (confirm("Are you sure you want to create a copy of this record?")){
                var cloneUrl = window.location.pathname + '/clone';
                var requestConfig = {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                axios.post(cloneUrl, {params:null}, requestConfig)
                .then(function(response){
                    var self = this;

                    if(!response.data.success) {
                        this.errorMessage = 'Save Failed';
                        this.errorSnackbar = true;
                    }
                    else if(response.data.success) {
                        console.log(response.data);
                        this.successSnackbar = true;

                        console.log("Perform post clone redirections");

                        // Post save redirect logic: at the moment just send the user to the list page
                        // as the data is not yet returned to specify what the ID of the newly created
                        // record is - returning to the list page is the only way to allow the user to
                        // find the newly created copy in a hurry
                        this.listView();
                    }
                }.bind(this));
            }
        },
        
        /**
         * Check to see if section should be displayed based on passed data
         *
         * @todo determine if this check is even needed any more now that we have more extensive server side validation
         */
        checkSection (section){
            console.log("section: ", section);
            var pass = true;
            // If section has rules
            if(section.rules.length > 0 && this.resultsArray){
                // Loop through the rules
				console.log(section.rules.length);
				console.log(section.rules);
                section.rules.forEach(function(value,key){
                    // Check data against rule operator
					console.log('Section rules...');
					console.log(value.operator);
					console.log(value.fielName);
					console.log(value.fieldName);
                    switch(value.operator) {
                        case '==' :
                            if(!(this.resultsArray[value.fieldName] == value.value)){
                                pass = false;                
                            }
                        break;
                        case '!=' :
                            if(!(this.resultsArray[value.fieldName] != value.value)){
                                pass = false;                
                            }
                        break;
                        case '<' :
                            if(!(this.resultsArray[value.fieldName] < value.value)){
                                pass = false;                
                            }
                        break;
                        
                        case '>' :
                            console.log("if > than:", this.resultsArray[value.fieldName],' > ',value.value);
                            console.log(this.resultsArray, value.fieldName);
                            if(!(this.resultsArray[value.fieldName] > value.value)){
                                console.log("should not show section");
                                pass = false;                
                            }
                        break;
                        
                        case '&' :
                            if(!(this.resultsArray[value.fieldName] & value.value)){
                                pass = false;                
                            }
                        break;
                    }
                }.bind(this));

            }
            // return result of check 
            return pass; 
        },

        /**
         * Checks if the database records featuring on this webpage have been saved since this page was opened
         */
        checkUpdatedUpstream(){
            axios.get('/ajax/' + this.metadata.editUrl + '/' + this.metadata.primaryKey + '/last-updated')
                .then(function(response){
                    this.lastUpdated = response.data.lastUpdated;

                    // If this page was last saved after this page was opened then set the flag to warn the user
                    this.updatedUpstream =  (this.lastUpdated > this.pageOpened) && (this.lastUpdated > this.lastSaved);

                    // And make a note of the fields that have changed so the user can be made aware they what data could be lost
                    this.upstreamChanges = response.data;
                }.bind(this));
        },

        /**
         * Formats an email to conveniently link the page to an email recipient in the users default email client
         */
        emailLink(){
            var emailAddress = '';
            var subject      = this.metadata.editUrl + ' ' + this.metadata.primaryKey;
            var body         = 'URL: ' + window.location.href;
            var url          = 'mailto:' + emailAddress + '?subject=' + subject + '&body=' + body;
            window.location.assign(url);
        },


        /**
         * Formats an email to conveniently link the page to an email recipient in the users default email client
         */
        reportProblem(){
            var emailAddress = 'web@i-escape.com';
            var subject      = 'Problem Report: ' + this.metadata.editUrl + ' ' + this.metadata.primaryKey;
            var body         = 'URL: ' + window.location.href;
            var url          = 'mailto:' + emailAddress + '?subject=' + subject + '&body=' + body;
            window.location.assign(url);
        },

        /**
         * Used when the page detects upstream changes and the user opts to discard their changes and load the page afresh
         * This could be done with Javascript and AJAX but it's far safer and easier to just reload
         */
         reloadPage(){
            location.reload();
         },

         /**
          * Used when the page detects upstream changes and the user asks to open the new page alongside the current one in a new tab so
          * they can manually see the differences and decide what to do for themselves
          */
         openNew(){
            window.open(window.location.href, '_blank');
         },

         /**
          * Finds instances of the specified model-field and updates their value accordingly
          */
         setFieldValue(modelName, fieldName, newValue){
             console.log("Before: ", this.formSections);

             this.formSections.forEach(function(section){
                 console.log(section);
                 section.fields.forEach(function(field){
                     console.log(field);
                     if (field.modelName == modelName && field.fieldName == fieldName){
                         console.log("Found it! is currently: ", field, " will set the value to be ", newValue);
                         field.value = newValue;
                     }
                 });
             });

             console.log("After: ", this.formSections);
             console.log("THIS", this);
         },

        /**
         * Automatically resolves any changes made upstream that are 
         */
        updatePage(){
            alert('Sorry, this feature is not yet available.  You must copy and paste the changes manually if you want to keep them');
        },


        /**
         *
         */
        returnToDashboard(){
            // Check if there are unsaved changes
            if (!this.unsavedChanges || confirm('If you leave this page before saving you will lose your changes')){
                //var url = '/' + this.metadata.parentPage;
                //window.location.assign(url);
                alert("This functionality is not yet available");
            }
        },

        /**
         * @method listView
         *
         * Establish the URL to which the user should be sent when requesting a corresponding
         * list page for this page
         */
        listView(){
            let listUrl;
            // Check if there are unsaved changes
            if (!this.unsavedChanges || confirm('If you leave this page before saving you will lose your changes')){
                if (window.location.pathname.includes('create')){
                    listUrl = this.populateUrlFromThisUrl(this.pageRecord.list_url, this.pageRecord.create_url);
                }
                else {
                    listUrl = this.populateUrlFromThisUrl(this.pageRecord.list_url, this.pageRecord.edit_url);
                }

                if (!listUrl){
                    return;
                }

                console.log("will redirect to list view: ", listUrl);
                window.location.assign(listUrl);
            }
        },

        /**
         * If new user was just created, it has '?new' in url and successSnackbar should display
         */
        checkForNewUser(){
            let url = window.location.href;
            if (url.includes('?new')) {
                this.successSnackbar = true;
            }
        },

        /**
         * Method will first check if we can redirect to new Url,
         * For some pages we want to wait until other AJAX calls will be done so we need to check if this is one of this page
         */
        safePageRedirect() {
            // here we store pages that we know that are using AJAX calls and we want to make sure that we won't reload page unitl all of them
            // will be done
            var delayPages = ['Admins', 'Hoteliers', 'Contractors'];

            if (delayPages.includes(this.metadata.editUrl)) {
                setTimeout(() => {
                    this.redirectPage();
                }, 2000)
            }
            else {
                this.redirectPage();
            }
        },

        /**
         * Method will instantly redirect to this.redirectToUrl, but only if this.redirectToUrl was set
         * this.redirectToUrl is being set when we're creating new user/model and we want to redirect for that user/model edit page
         */
        redirectPage() {
            if (this.redirectToUrl) {
                window.location.assign(this.redirectToUrl);
            }
        },
    },
    computed:{
        'resultsArray': {
            get:function(){
                if(this.resultsData['data'] && this.resultsData['data'][0]){
                    return this.resultsData['data'][0];
                }
                else{
                    return [];
                }
            },
            set:function(val){
            }
        }
    },

    // This is a crude way to check for changes, and highlight them if any are detected
    // We are trying to avoid having to ask the components to report when theyve been
    // changed themselves, but that is perhaps the best way
/*
    watch: {

        formSections: function(newValue, oldValue){
            this.unsavedChanges = true;
            alert("form sections change detected");
        }
    },
*/
    // All initialisation actions that should be performed on page ready
    mounted: function () {
        try{
console.log("Edit form created:", this);
        // create copy of main app vue 'this' so we can call 'this' functions from eventHub scope
        var _this = this;

        this.pageRecord = JSON.parse(this.page);
console.log('page record', this.pageRecord);
        this.formSections = this.sectionsData;
console.log(this.formSections);


        // Set up a interval timer to poll the server using AJAX for the last time the records behind this page's content were updated
        // This is used to reduce the likelihood of another user causing data conflicts with this one by both editing the same content at the same time
        if (this.metadata.primaryKey){
            setInterval(function () {
                this.checkUpdatedUpstream();
            }.bind(this), 10000);
        }

        this.checkForNewUser();

        // Register an event listener to respond to updates in child components data
        // or request that those values are changed to the given value
        this.$root.$on('Edit: Update Field', function(payload){
            console.log("edit component: update field value heard", payload);
            var modelName = payload.field.modelName;
            var fieldName = payload.field.fieldName;
            var newValue = payload.value;


            console.log("shoudl set: ", modelName, fieldName, newValue);
            _this.setFieldValue(modelName, fieldName, newValue);
        });


        // Register an event listener callback functions which can listen for other vue components
        this.$eventHub.$on('associations-saved', function(data) {
            _this.redirectPage();
        });

        }catch(exception){
            console.log(exception);
            this.isBroken = true;
        }
        console.log("EDIT mounted, page record: ", this.pageRecord);
    }


}
</script>

<style>
    .ies-actions td:first-child{
        padding:0px;
    }

    input:disabled {
        background: #dddddd;
    }

    #editForm .col {
        padding-top: 4px;
        padding-bottom: 4px;
    }
</style>
